module.exports = __webpack_public_path__ + "static/img/patent2.f5b2c1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/patent2.png
// module id = 16+K
// module chunks = 0